import {Aseprite} from '@theatrejs/plugin-aseprite';import data from './wall.json';import texture from './wall.png';export default new Aseprite(texture, data);